import { useQuery } from '@tanstack/react-query'

import API from '../../../utils/api'

export const useCatalogPopular = () => {
  const { data, isLoading, refetch, error } = useQuery(
    ['/GamesCatalog/popular'],
    API.getPopularGames,
    {
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  )

  return {
    games: data?.data?.games || [],
    refetch,
    error,
    isLoading,
  }
}
